import React, { useState, useEffect } from "react";
import { api } from "../features/apiServices/apiClient";
import { useNavigate } from "react-router-dom";
import ModalMesaClick from "../components/ModalMesaClick";
import ConfirmModal from "../components/ConfirmModal";
import "./css/CadastroRestPage.css";
import safeJSON from "../components/safeJSON";

const CadastroRestPage = () => {
  const navigate = useNavigate();

  const token = localStorage.getItem("acssesToken");
  const tenant = safeJSON("tenant");


  //const tenant = JSON.parse(localStorage.getItem("tenant"));
  //const user = JSON.parse(localStorage.getItem("user"));

  const storedRestaurants = JSON.parse(localStorage.getItem("restaurants") || "[]");
  const [restaurants, setRestaurants] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [restaurantID, setRestaurantID] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [editingId, setEditingId] = useState(null);
  //const [activeRestaurant, setActiveRestaurant] = useState(JSON.parse(localStorage.getItem("activeRestaurant") || "null"));

  const [formData, setFormData] = useState({
    nome: "",
    cnpj: "",
    quantidade_mesas: "",
    contact_email: "",
    contact_phone: "",
    slug: "",
    timezone: "America/Sao_Paulo",
    address: {
      rua: "",
      numero: "",
      cidade: "",
      uf: "",
      cep: "",
    },
    logo_url: null,

  });

  const Headers = {
    Authorization: `Bearer ${token}`,
    "x-tenant-slug": tenant.slug,
  }

  const loadRestaurants = async () => {
    try {
      const response = await api.get("/restaurant", { headers: Headers });

      const list = response.data.restaurants || response.data;

      setRestaurants(list);
      localStorage.setItem("restaurants", JSON.stringify(list));
    } catch (err) {
      console.error("Erro ao buscar restaurantes:", err);
    }
  };

  useEffect(() => {
    if (!localStorage.getItem("accessToken")) return;
    
    loadRestaurants();
  }, []);



  /* ============================================================
     HANDLE CHANGE (FORM)
  ============================================================ */
  const handleChange = (e) => {
    const { name, value } = e.target;

    // Campos do endereço
    if (name.startsWith("address.")) {
      const field = name.split(".")[1];
      setFormData((prev) => ({
        ...prev,
        address: {
          ...prev.address,
          [field]: value,
        },
      }));
      return;
    }

    // Auto gerar slug
    if (name === "nome") {
      const slug = value
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/\s+/g, "-");

      setFormData((prev) => ({
        ...prev,
        nome: value,
        slug,
      }));
      return;
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  /* ============================================================
     CADASTRAR RESTUARANTE
  ============================================================ */
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await api.post("/restaurant",
        {
          ...formData,
          quantidade_mesas: Number(formData.quantidade_mesas),
        },
        {
          headers: Headers
        }
      );


      setModalMessage("Restaurante cadastrado com sucesso!");
      setModalOpen(true);
      resetForm();
      await loadRestaurants();

    } catch (err) {
      setModalMessage("Erro ao cadastrar restaurante:", err);
      setModalOpen(true);

      //console.error("Erro ao cadastrar restaurante:", err);
      //alert("Erro ao cadastrar restaurante.");
    }
  };

  /* ============================================================
     EDITAR RESTAURANTE
  ============================================================ */
  const handleEdit = (rest) => {
    setIsEditing(true);
    setEditingId(rest.id);

    setFormData({
      nome: rest.nome,
      cnpj: rest.cnpj || "",
      quantidade_mesas: rest.quantidade_mesas || "",
      contact_email: rest.contact_email || "",
      contact_phone: rest.contact_phone || "",
      slug: rest.slug,
      timezone: rest.timezone || "America/Sao_Paulo",
      address: rest.address || {
        rua: "",
        numero: "",
        cidade: "",
        uf: "",
        cep: "",
      },
      logo_url: null
    });
  };

  /* ============================================================
     SALVAR ALTERAÇÕES
  ============================================================ */
  const handleUpdate = async (e) => {
    e.preventDefault();

    try {
      /* ===============================
         AJUSTE DE MESAS ANTES DO UPDATE
      =============================== */
      const restaurantId = editingId;
      const newCount = Number(formData.quantidade_mesas);

      // 1. Buscar mesas atuais
      const respTables = await api.get(`/tables?restaurant_id=${restaurantId}`, { headers: Headers });


      const mesasAtuais = (respTables.data || []).filter(
        (m) => !m.name.toLowerCase().startsWith("delivery")
      );
      const qtdAtual = mesasAtuais.length;



      /* ===============================
         2. Aumentou a quantidade?
      =============================== */
      if (newCount > qtdAtual) {
        const qtdAdicionar = newCount - qtdAtual;

        for (let i = 0; i < qtdAdicionar; i++) {
          await api.post(
            "/tables",
            {
              restaurant_id: restaurantId,
              name: `Mesa ${qtdAtual + i + 1}`,
              capacity: 4,
            },
            {
              headers: Headers
            }
          );
        }
      }

      /* ===============================
         3. Diminuiu a quantidade?
      =============================== */
      if (newCount < qtdAtual) {
        const qtdRemover = qtdAtual - newCount;

        // Buscar novamente as mesas atualizadas
        const respRefresh = await api.get(`/tables?restaurant_id=${restaurantId}`, { headers: Headers });

        let mesasLista = (respRefresh.data || []).filter(
          (m) => !m.name.toLowerCase().startsWith("delivery")
        );

        /* ==================================================
           Ordenar do jeito certo
           - Extrair o número da mesa do nome ("Mesa 12")
           - Ordenar do maior número → menor número
        ================================================== */
        mesasLista = mesasLista.sort((a, b) => {
          const numA = parseInt(a.name.replace(/\D+/g, "")) || 0;
          const numB = parseInt(b.name.replace(/\D+/g, "")) || 0;
          return numB - numA; // maior primeiro
        });

        /* ==================================================
           Filtrar apenas mesas livres
        ================================================== */
        const mesasLivres = mesasLista.filter((m) => m.status === "available");

        /* ==================================================
           Selecionar exatamente as mesas finais para remover
        ================================================== */
        const mesasParaExcluir = mesasLivres.slice(0, qtdRemover);

        /* ==================================================
           Excluir uma por uma
        ================================================== */
        for (const mesa of mesasParaExcluir) {
          await api.delete(`/tables/${mesa.id}`, {
            headers: Headers
          });
        }
      }

      /* ===============================
         4. Após ajustar mesas → Atualiza restaurante
      =============================== */
      const response = await api.put(
        `/restaurant/${restaurantId}`,
        {
          ...formData,
          quantidade_mesas: Number(formData.quantidade_mesas),
        },
        {
          headers: Headers
        }
      );

      const updatedRestaurant = response.data;

      let storedRestaurants = JSON.parse(localStorage.getItem("restaurants")) || [];

      storedRestaurants = storedRestaurants.map((r) =>
        r.id === updatedRestaurant.id ? updatedRestaurant : r
      );

      localStorage.setItem("restaurants", JSON.stringify(storedRestaurants));

      const activeRestaurant = JSON.parse(localStorage.getItem("activeRestaurant"));

      if (activeRestaurant && activeRestaurant.id === updatedRestaurant.id) {
        localStorage.setItem(
          "activeRestaurant",
          JSON.stringify(updatedRestaurant)
        );
      }


      setModalMessage("As alterações foram salvas com sucesso!");
      setModalOpen(true);
      resetForm();
      await loadRestaurants();

    } catch (err) {
      setModalMessage(`Erro ao atualizar restaurante: ${err}`);
      setModalOpen(true);
      //console.error("Erro ao atualizar restaurante:", err);
      //alert("Erro ao atualizar restaurante.");
    }
  };


  /* ============================================================
    EXCLUIR
  ============================================================ */
  const openModalDelete = async (id) => {
    setRestaurantID(id);
    setConfirmModalOpen(true);

  };

  const handleDelete = async () => {
    try {
      await api.delete(`/restaurant/${restaurantID}`, { headers: Headers });

      setConfirmModalOpen(false);
      setModalMessage("Restaurante excluido com sucesso!");
      setModalOpen(true);

      await loadRestaurants();



    } catch (err) {
      setModalMessage(`Erro ao excluir restaurante: ${err}`);
      setModalOpen(true);

      //console.error("Erro ao excluir restaurante:", err);
      //alert("Erro ao excluir restaurante.");
    }
  };

  /* ============================================================
     RESET
  ============================================================ */
  const resetForm = () => {
    setIsEditing(false);
    setEditingId(null);
    setFormData({
      nome: "",
      cnpj: "",
      quantidade_mesas: "",
      contact_email: "",
      contact_phone: "",
      slug: "",
      timezone: "America/Sao_Paulo",
      address: {
        rua: "",
        numero: "",
        cidade: "",
        uf: "",
        cep: "",
      },
    });
  };

  /* ============================================================
     RENDER
  ============================================================ */
  return (
    <div className="page-container">

      {/* ================= HEADER ==================== */}
      <header className="header">
        <img
          src="/assets/logo-mesaclick.png"
          alt="MesaClick Logo"
          className="header-logo"
          onClick={() => navigate("/Home")}
        />
        <h1 className="header-title">Cadastro de Restaurantes</h1>
      </header>

      {/* ================= LAYOUT ==================== */}
      <div className="split-container">

        {/* ================================================= */}
        {/*                   FORM ESQUERDA                  */}
        {/* ================================================= */}
        <div className="left-pane">
          <h2 className="section-title">
            {isEditing ? "Editar Restaurante" : "Novo Restaurante"}
          </h2>

          <form onSubmit={isEditing ? handleUpdate : handleSubmit}>
            <div className="form-section">
              <h3 className="section-sub">Dados do Restaurante</h3>

              <div className="form-group">
                <label className="label">Nome</label>
                <input
                  type="text"
                  name="nome"
                  value={formData.nome}
                  onChange={handleChange}
                  className="input"
                  required
                />
              </div>

              <div className="form-group">
                <label className="label">CNPJ</label>
                <input
                  type="text"
                  name="cnpj"
                  value={formData.cnpj}
                  onChange={handleChange}
                  className="input"
                />
              </div>

              <div className="form-group">
                <label className="label">Quantidade de Mesas</label>
                <input
                  type="number"
                  name="quantidade_mesas"
                  value={formData.quantidade_mesas}
                  onChange={handleChange}
                  className="input"
                />
              </div>

              <div className="form-group">
                <label className="label">Logo do Restaurante</label>
                <input
                  type="file"
                  name="logo"
                  accept="image/*"
                  onChange={(e) => setFormData({ ...formData, logo_url: e.target.files[0] })}
                  className="input"
                />
              </div>


              {/* <div className="form-group">
                <label className="label">Slug (automático)</label>
                <input
                  type="text"
                  name="slug"
                  value={formData.slug}
                  className="input"
                  disabled
                />
              </div> */}
            </div>

            {/* ====================== */}
            {/* CONTATO                */}
            {/* ====================== */}
            <div className="form-section">
              <h3 className="section-sub">Contato</h3>

              <div className="form-group">
                <label className="label">E-mail</label>
                <input
                  type="email"
                  name="contact_email"
                  value={formData.contact_email}
                  onChange={handleChange}
                  className="input"
                />
              </div>

              <div className="form-group">
                <label className="label">Telefone</label>
                <input
                  type="text"
                  name="contact_phone"
                  value={formData.contact_phone}
                  onChange={handleChange}
                  className="input"
                />
              </div>
            </div>

            {/* ====================== */}
            {/* ENDEREÇO               */}
            {/* ====================== */}
            <div className="form-section">
              <h3 className="section-sub">Endereço</h3>

              <div className="form-group">
                <label className="label">Rua</label>
                <input
                  type="text"
                  name="address.rua"
                  value={formData.address.rua}
                  onChange={handleChange}
                  className="input"
                />
              </div>

              <div className="form-group">
                <label className="label">Número</label>
                <input
                  type="text"
                  name="address.numero"
                  value={formData.address.numero}
                  onChange={handleChange}
                  className="input"
                />
              </div>

              <div className="form-group">
                <label className="label">Cidade</label>
                <input
                  type="text"
                  name="address.cidade"
                  value={formData.address.cidade}
                  onChange={handleChange}
                  className="input"
                />
              </div>

              <div className="form-group">
                <label className="label">UF</label>
                <input
                  type="text"
                  name="address.uf"
                  maxLength="2"
                  value={formData.address.uf}
                  onChange={handleChange}
                  className="input"
                />
              </div>

              <div className="form-group">
                <label className="label">CEP</label>
                <input
                  type="text"
                  name="address.cep"
                  value={formData.address.cep}
                  onChange={handleChange}
                  className="input"
                />
              </div>
            </div>

            {/* ====================== */}
            {/* BOTÕES                 */}
            {/* ====================== */}
            <div className="form-buttons">
              {isEditing && (
                <button
                  type="button"
                  onClick={resetForm}
                  className="btn-cancel"
                >
                  Cancelar
                </button>
              )}
              <button type="submit" className="btn-save">
                {isEditing ? "Salvar" : "Cadastrar"}
              </button>
            </div>
          </form>
        </div>

        {/* ================================================= */}
        {/*            LISTA DE RESTAURANTES (DIREITA)        */}
        {/* ================================================= */}
        <div className="right-pane">
          <h2 className="section-title">Restaurantes Cadastrados</h2>

          <div className="rest-list">
            {restaurants.length === 0 && (
              <p className="empty-text">
                Nenhum restaurante cadastrado ainda.
              </p>
            )}

            {restaurants.map((rest) => (
              <div key={rest.id} className="rest-card">
                <h3 className="rest-name">{rest.nome}</h3>

                <p className="rest-info">
                  <strong>Cnpj:</strong> {rest.cnpj}
                </p>

                <p className="rest-info">
                  <strong>Mesas:</strong> {rest.quantidade_mesas}
                </p>

                <p className="rest-info">
                  <strong>Email:</strong> {rest.contact_email || "--"}
                </p>

                <p className="rest-info">
                  <strong>Telefone:</strong> {rest.contact_phone || "--"}
                </p>

                {/* <p className="rest-info">
                  <strong>Slug:</strong> {rest.slug}
                </p> */}

                <div className="rest-btns">
                  <button
                    className="btn-edit"
                    onClick={() => handleEdit(rest)}
                  >
                    Editar
                  </button>

                  <button
                    className="btn-delete"
                    onClick={() => openModalDelete(rest.id)}
                  >
                    Excluir
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
      <ModalMesaClick
        open={modalOpen}
        message={modalMessage}
        onClose={() => setModalOpen(false)}
      />

      <ConfirmModal
        show={confirmModalOpen}
        onCancel={() => setConfirmModalOpen(false)}
        onConfirm={() => handleDelete()}

      />

    </div>


  );
};

export default CadastroRestPage;
